import { STATUS_DATA } from "../../data/roles.js";
import { useGame } from "../../context/GameContext.jsx";

export function PlayerStatusBadges({ player, session: sessionProp }) {
  const { state } = useGame();
  const session = sessionProp ?? state.session;
  const elderHasLife = player.baseRoleId === "elder" && player.alive && !session?.elder_usedSurvival;
  const elderLostLife = player.baseRoleId === "elder" && player.alive && session?.elder_usedSurvival;
  return (
    <span className="flex gap-0.5 flex-wrap text-xs">
      {player.statuses.map(s => (
        <span key={s} title={STATUS_DATA[s]?.frenchName}>{STATUS_DATA[s]?.emoji}</span>
      ))}
      {player.baseRoleId === "wild_child" && player.effectiveAlignment === "werewolf" && (
        <span title="Transformé" className="text-[10px] font-bold text-red-400">🐺</span>
      )}
      {elderHasLife && <span title="Vie supplémentaire disponible" className="text-[10px] text-yellow-400">+1❤️</span>}
      {elderLostLife && <span title="Vie supplémentaire consommée" className="text-[10px] text-stone-500">0💔</span>}
      {(player.sheepCount || 0) > 0 && (
        <span title="Moutons possédés" className="text-[10px] text-stone-300">+{player.sheepCount}🐑</span>
      )}
    </span>
  );
}
